<template>
  <div class="w-11/12">
    <div class="flex justify-center">
      <img
        :src="require('@/assets/experiences/' + propData.img)"
        :class="propData.img_size"
      />
    </div>
    <div class="font-semibold text-gray-800 tracking-wider mt-6">
      {{ propData.name }}
    </div>
    <div class="font-light text-gray-600 tracking-wider mt-6 text-sm">
      {{ propData.tile_subtitle }}
    </div>

    <div class="w-full text-center">
      <p class="mt-6 text-gray-600 text-xs">{{ propData.desc }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    propData: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style scoped lang="scss">
.sm {
  max-width: 50% !important;
}
.lg {
  max-width: 120% !important;
}

p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>